package com.yendo.mx.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ConfiguracionZona(
    val id_zona: String = "",
    val app_info: AppInfoConfig = AppInfoConfig(),
    val alerta_operativa: AlertaZonaConfig = AlertaZonaConfig(),
    val finanzas_cliente: FinanzasClienteConfig = FinanzasClienteConfig(),
    val finanzas_negocio: FinanzasNegocioConfig = FinanzasNegocioConfig(),
    val finanzas_operativas: FinanzasOperativasConfig = FinanzasOperativasConfig(),
    val finanzas_repartidor: FinanzasRepartidorConfig = FinanzasRepartidorConfig(),
    val logistica: LogisticaConfig = LogisticaConfig(),
    val logistica_poligonos: LogisticaPoligonosConfig = LogisticaPoligonosConfig(),
    val logistica_radios: LogisticaRadiosConfig = LogisticaRadiosConfig(),
    val modulos: ModulosZonaConfig = ModulosZonaConfig(),
    val clasificacion: ClasificacionConfig = ClasificacionConfig(),
    val operacion: OperacionConfig = OperacionConfig(),
    val prevencion_fraude: PrevencionFraudeConfig = PrevencionFraudeConfig(),
    val reglas_contables: ReglasContablesConfig = ReglasContablesConfig(),
    val tiempos_y_reglas: TiemposReglasConfig = TiemposReglasConfig(),
    val promo_flash: PromoFlashConfig? = null
)

@Serializable
data class PromoFlashConfig(
    val activa: Boolean = false,
    val imagen: String = "",
    val tipo_accion: String = "NINGUNA",
    val destino_accion: String = ""
)

// 🚀 SEPARAMOS COMIDA Y COMERCIOS PARA EL CATÁLOGO
@Serializable
data class ClasificacionConfig(
    val restaurantes: List<CategoriaDirectorio> = emptyList(),
    val comercios: List<CategoriaDirectorio> = emptyList()
)

@Serializable
data class CategoriaDirectorio(
    val nombre: String = "",
    val emoji: String = "",
    val activa: Boolean = true,
    val subcategorias_sugeridas: List<String> = emptyList()
)

@Serializable
data class ModulosZonaConfig(
    @SerialName("comercios_activo") val comerciosActivo: Boolean = false,
    @SerialName("envios_activo") val enviosActivo: Boolean = false,
    @SerialName("tiendita_activa") val tienditaActiva: Boolean = false
)

@Serializable
data class AlertaZonaConfig(
    val mostrar_alerta: Boolean = false,
    val mensaje: String = "",
    val tipo: String = "INFO" // Puede ser "INFO" (Azul), "WARNING" (Naranja/Lluvia), "DANGER" (Rojo)
)
@Serializable
data class AppInfoConfig(
    val activo: Boolean = true,
    val nombre_zona: String = ""
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class FinanzasClienteConfig(
    val costo_km: Long = 10L,
    val envio_minimo: Long = 15L,
    val tarifa_inicial: Long = 5L,
    val tarifa_servicio_fija: Long = 0L,
    val tarifa_servicio_porcentaje: Double = 0.05, // Firebase es Double
    val metodos_pago_activos: List<String> = listOf("Efectivo", "Tarjeta", "Transferencia"),
    // 🚀 CONTROLES EXCLUSIVOS PARA MANDADITOS (P2P)
    val mandaditos_metodos_pago_activos: List<String> = emptyList(),
    val mandaditos_vehiculos_desactivados: List<String> = emptyList(),
    val mandaditos_tipos_paquete: List<String> = listOf("Documentos", "Paquete Chico", "Paquete Mediano", "Otros"),
    // 🚀 NUEVOS MAPAS DINÁMICOS
    val multiplicadores_vehiculo: Map<String, Double> = emptyMap(),
    // 🚀 VARIABLES EXCLUSIVAS PARA MANDADITOS (P2P)
    val mandaditos_tarifa_inicial: Long = 15L,
    val mandaditos_costo_km: Long = 5L,
    val mandaditos_envio_minimo: Long = 35L,
    val mandaditos_tarifa_servicio_fija: Long = 0L,
    val mandaditos_tarifa_servicio_porcentaje: Double = 0.10
)

@Serializable
data class FinanzasNegocioConfig(
    val comision_global_porcentaje: Double = 0.15 // Firebase es Double
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class FinanzasOperativasConfig(
    val esquema: String = "BASICO",
    val max_deuda_repartidor: Long = 1500L,
    @SerialName("max_deuda_negocio") val max_deuda_negocio: Long = 2000L
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class FinanzasRepartidorConfig(
    val limite_deuda_efectivo: Long = 300L,
    val pago_fijo_entrega: Long = 0L,
    val pago_fijo_recolecta: Long = 0L,
    val porcentaje_sobre_envio: Double = 1.0 // Firebase es Double
)

@Serializable
data class LogisticaConfig(
    val delivery_activo: Boolean = true,
    val pickup_activo: Boolean = true,
    val envios_pausados: Boolean = false, // 🚀 SE MOVIÓ AQUÍ
    val envios_programados_activos: Boolean = true // 🚀 SE MOVIÓ AQUÍ
)

@Serializable
data class LogisticaPoligonosConfig(
    val exclusion: List<String> = emptyList(),
    val servicio: List<String> = emptyList()
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class LogisticaRadiosConfig(
    val asignacion_repartidor_km: Long = 5L,
    val entrega_maxima_km: Long = 5L,
    @SerialName("mostrar_negocios_m") val mostrar_negocios_m: Long = 5000L,
    val tolerancia_entregado_m: Long = 100L,
    val tolerancia_recolectado_m: Long = 100L,
    // 🚀 NUEVA VARIABLE PARA EL CHECKOUT (ALERTA DE LEJANÍA)
    val limite_alerta_ubicacion_m: Long = 500L
)

@Serializable
data class HorarioDiario(
    val apertura: String = "08:00",
    val cierre: String = "22:00",
    val activo: Boolean = true
)

@Serializable
data class OperacionConfig(
    val programados_activos: Boolean = true,
    val horario_semanal: Map<String, HorarioDiario> = emptyMap() // 🚀 UNICA FUENTE DE VERDAD
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class PrevencionFraudeConfig(
    val maximo_efectivo_pedido: Long = 1000L,
    val pedidos_tarjeta_requeridos: Long = 0L
)

@Serializable
data class ReglasContablesConfig(
    val metodo_pago_a_negocio: String = "TOTAL",
    val recaudador_ganancias_efectivo: String = "NEGOCIO",
    val tipo_sistema_balance: String = "FONDEO_REPARTIDOR"
)

// 🔥 CORREGIDOS LOS INT64 a LONG
@Serializable
data class TiemposReglasConfig(
    @SerialName("aceptacion_negocio_min") val aceptacion_negocio_min: Long = 5L,
    val bateria_minima_repartidor: Long = 15L,
    val tipo_asignacion: String = "BROADCAST"
)